import { History } from "history";

import { PaginateQuery, TeacherDto } from "../../../interfaces";
import { Paginated } from "../../../models";

//#region Get Student Users

export const GET_TEACHERS = "GET_TEACHERS";
export const GET_TEACHERS_SUCCESS: any = "GET_TEACHERS_SUCCESS";
export const GET_TEACHERS_ERROR: any = "GET_TEACHERS_ERROR";

export interface GetTeachersAction {
  type: typeof GET_TEACHERS;
  payload: {
    request: PaginateQuery;
    history: History;
  };
}

export interface GetTeachersSuccessAction {
  type: typeof GET_TEACHERS_SUCCESS;
  payload: Paginated<TeacherDto>;
}

export interface GetTeachersErrorAction {
  type: typeof GET_TEACHERS_ERROR;
  payload: any;
}
//#endregion

// Export a union type that represents all possible actions
export type ActionTypes =
  | GetTeachersAction
  | GetTeachersSuccessAction
  | GetTeachersErrorAction;
